import { IconType } from '@chargify/icons';

import { MessageType } from './types';

export const MESSAGE_ICON: Record<MessageType, IconType> = {
  success: 'circleCheck',
  warning: 'exclamationTriangle',
  info: 'circleInfo',
};
